import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { PagesHeaderComponent } from '../../components/pages-header/pages-header.component';
import { BuyerFooterComponent } from 'src/app/Shared/components/buyer-footer/buyer-footer.component';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { BreadCrumbsComponent } from '../../../../Shared/components/bread-crumbs/bread-crumbs.component';
import { isPlatformBrowser } from '@angular/common';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

@Component({
    selector: 'app-about-us',
        standalone: true,
imports: [BreadCrumbsComponent,
        TranslatePipe
    ],
    templateUrl: './about-us.component.html',
    styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  breadcrumbs: Breadcrumb[] = [];

  currentLang: any;

  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private translate: TranslateService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
    }
  }
}
